import { render } from "./SendActionsBlock.vue?vue&type=template&id=20698db6"
import script from "./SendActionsBlock.vue?vue&type=script&lang=js"
export * from "./SendActionsBlock.vue?vue&type=script&lang=js"

import "./SendActionsBlock.vue?vue&type=style&index=0&id=20698db6&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__